import {displayPhoneNumber} from 'Src/utilities/Helpers'
import {resolveErrorPageMessage} from 'Src/utilities/errorPageMessage'

/**
 * User-facing copy at the top of /register during error-screen lead capture.
 * Uses the same message resolution as Error.tsx — no custom banner text.
 */
export const getErrorScreenRegistrationBannerMessage = ({
  dealershipPhone,
  vehicle,
  embedVehicle,
  cause,
}: {
  dealershipPhone?: string | null
  vehicle?: Record<string, unknown> | null
  embedVehicle?: Record<string, unknown> | null
  cause?: string | null
} = {}): string =>
  resolveErrorPageMessage({
    dealershipPhone,
    vehicle,
    embedVehicle,
    deferredErrorCause: cause,
  })

export const getErrorScreenLeadSuccessHeadline = () => "Thank you! We'll be in touch soon."

export const getErrorScreenLeadSuccessBody = (dealershipPhone?: string | null) => {
  if (dealershipPhone) {
    return `One of our team members will reach out to help you with your vehicle inquiry. In the meantime, feel free to call us directly at ${displayPhoneNumber(
      dealershipPhone
    )}.`
  }

  return 'One of our team members will reach out to help you with your vehicle inquiry. In the meantime, feel free to call us directly.'
}

/** Toast after successful error-screen lead + OTP (replaces deferred API error toast). */
export const getErrorScreenLeadSuccessMessage = (dealershipPhone?: string | null) => ({
  title: getErrorScreenLeadSuccessHeadline(),
  description: getErrorScreenLeadSuccessBody(dealershipPhone),
  type: 'success' as const,
  autohide: false,
})

/** Friendly message when /customers/leads/verify fails on Continue. */
export const parseRegistrationSubmitError = (error: unknown): string => {
  const response = (error as {response?: {data?: Record<string, unknown>}})?.response
  const data = response?.data

  if (Array.isArray(data?.errors)) {
    const details = (data.errors as Array<{detail?: string}>).map((e) => e.detail).filter(Boolean)

    if (details.length > 0) {
      return details.join(' ')
    }
  }

  for (const [, messages] of Object.entries(data || {})) {
    if (Array.isArray(messages) && messages.every((m) => typeof m === 'string')) {
      return messages.join(' ')
    }
  }

  return 'Sorry, we could not continue with registration. Please try again.'
}
